import urls from "../../../../global/constants/UrlConstants";
import {
  getCallParams,
  getNoAuthCallParams,
  makeCall,
} from "../../../../utils/service";

export async function getAllUsers(payload:any) {
  try {
    const callParams = await getCallParams("GET");
    // const response = await makeCall(urls.GETALLUSER, callParams);
    const response = await makeCall(
      `${urls.GETALLUSER}?start_date=${payload.startDate || ""}&end_date=${payload.endDate || ""}&page=${payload.pageNumber || 0}&limit=${payload.pageSize ||25}&team_id=${payload.team_id || ""}&search=${payload.search || ""}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getDateWiseTeam(
  // userId: string,
  // from: string,
  // to: string
  payload:any
) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETALLUSER + `?id=${payload.userId}&start_date=${payload.from}&end_date=${payload.to}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}
export async function postOfficeDetails() {
  try {
    const callParams = await getCallParams("POST");
    const response = await makeCall(urls.ADDUSEROFFICE, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
}

export async function changeUserPassword(payload: any) {
  try {
    const callParams = await getCallParams("POST", payload);
    const response = await makeCall(urls.EDITPASSWORD, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
}

export async function changeStatusApi(status: any, userId: any) {
  const payload = {
    id: userId,
    status: status == 0 || status === "0" ? "1" : "0",
  };
  try {
    const callParams = await getCallParams("PUT", payload);
    const response = await makeCall(urls.USERUPDATE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

/**
 * Grant / revoke named extra access for one team member (admin only).
 * Keys must match USER_GRANTS on the backend.
 */
export async function setUserGrantsApi(
  userId: any,
  grants: Record<string, boolean>
) {
  try {
    const callParams = await getCallParams("PUT", { id: userId, grants });
    const response = await makeCall(urls.LEADEXPORTACCESS, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getIVRUsers() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      `${urls.GETIVRUSERS}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

  export async function updateUnmapUser(payload: any) {
    try {
      const callParams = await getCallParams("PUT", payload);
      const response = await makeCall(urls.USERMAP, callParams);
      return response;
    } catch (error) {
      throw error;
    }
  }
  export async function clickToCall(payload:any) {
  try {
    const callParams = await getCallParams("POST",payload);
    const response = await makeCall(urls.CLICKTOCALL, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
}
